export function filtrarTroncosParaOCallback(scripttrunk, PermissionRouter) {
  const hasPermissionRouter =
    Boolean(PermissionRouter) && Array.isArray(PermissionRouter);
  if (!hasPermissionRouter) return PermissionRouter;
  const filteredPermissionRouter = PermissionRouter.filter(
    (route) =>
      parseInt(scripttrunk) === parseInt(route.scripttrunk) ||
      scripttrunk === route.scripttrunk
  );
  const hasFilteredPermissionRouter =
    Array.isArray(filteredPermissionRouter) &&
    filteredPermissionRouter.length > 0;
  if (!hasFilteredPermissionRouter) return PermissionRouter;
  return filteredPermissionRouter;
}
